"use client"

import { useEffect, useState } from "react"
import axios from "axios"
import * as XLSX from "xlsx"
import { motion, AnimatePresence } from "framer-motion"
import {
  DownloadIcon as FiDownload,
  FileSearchIcon as FiSearch,
  FilterIcon as FiFilter,
  Trash2Icon as FiTrash2,
  RefreshCwIcon as FiRefreshCw,
  ChevronLeftIcon as FiChevronLeft,
  ChevronRightIcon as FiChevronRight,
  CheckIcon as FiCheck,
  EyeIcon as FiEye,
  XIcon as FiX,
  Sparkles,
  CreditCardIcon as FiCreditCard,
} from "lucide-react"
import { getAppointmentTransactions } from "../utils/api"
import { useQuery } from "@tanstack/react-query"
import moment from "moment"
import { FaExchangeAlt } from "react-icons/fa"

const MeetingAppointmentTransactions = () => {
  const [selectedTransaction, setSelectedTransaction] = useState(null);
  const [isModalOpen, setIsModalOpen] = useState(false);

  const { data: transactions, isLoading, refetch } = useQuery({
    queryKey: ['appointmenttransactions'],
    queryFn: getAppointmentTransactions
  })

  const mergedRows = transactions?.data?.map((t, index) => ({
    "S.No": index + 1,

    "Transaction ID": t.transactionId,

    "Transaction Date": moment(t.createdAt).format("DD MMM YYYY"),
    "Transaction Time": moment(t.createdAt).format("hh:mm A"),

    "Meeting Title": t.meeting?.title || "N/A",
    "Meeting Date": t.meeting?.date
      ? moment(t.meeting.date).format("DD MMM YYYY")
      : "N/A",

    "Startup Name": t.startup?.name,
    "Startup Email": t.startup?.email,

    "Mentor Name": t.mentor?.name,
    "Mentor Email": t.mentor?.email,

    "Amount Paid": t.amountPaid,
    "Commission": t.commissionAmount,
    "Mentor Payout": t.mentorPayout,

    "Payment Status": t.payment?.status,
    "Order ID": t.payment?.orderId,
    "Payment ID": t.payment?.paymentId,
  }));

  const handleDownloadExcel = () => {
    if (!mergedRows || mergedRows.length === 0) return;

    const ws = XLSX.utils.json_to_sheet(mergedRows);
    const wb = XLSX.utils.book_new();

    XLSX.utils.book_append_sheet(wb, ws, "Appointment Transactions");

    XLSX.writeFile(wb, "Appointment_Transactions_Report.xlsx");
  };






  

  useEffect(() => {
    console.log(transactions)
  }, [transactions])

  const Detail = ({ label, value }) => (
    <div className="flex flex-col">
      <span className="text-xs text-gray-500">{label}</span>
      <span className="text-sm font-semibold text-gray-900 break-all">
        {value ?? "—"}
      </span>
    </div>
  );


  return (
    <>
      <div className="min-h-screen bg-gradient-to-br from-slate-50 via-blue-50 to-indigo-50 py-8 px-4">
        {/* Background Pattern */}
        <div className='absolute inset-0 bg-[url("data:image/svg+xml,%3Csvg width="60" height="60" viewBox="0 0 60 60" xmlns="http://www.w3.org/2000/svg"%3E%3Cg fill="none" fillRule="evenodd"%3E%3Cg fill="%239C92AC" fillOpacity="0.05"%3E%3Ccircle cx="30" cy="30" r="2"/%3E%3C/g%3E%3C/g%3E%3C/svg%3E")] opacity-40 pointer-events-none' />
        <div className="relative z-10 max-w-7xl mx-auto">
          {/* Header */}
          <motion.div
            initial={{ opacity: 0, y: -20 }}
            animate={{ opacity: 1, y: 0 }}
            className="backdrop-blur-xl bg-white/80 border border-white/20 shadow-xl rounded-3xl p-6 mb-8"
          >
            <div className="flex flex-col xl:flex-row justify-between items-start xl:items-center gap-4">
              <div className="flex items-center gap-4">
                <div className="w-14 h-14 bg-gradient-to-r from-blue-600 to-indigo-600 rounded-2xl flex items-center justify-center shadow-lg">
                  <FaExchangeAlt className="text-white text-2xl" />
                </div>
                <div>
                  <h1 className="text-3xl font-bold bg-gradient-to-r from-gray-900 to-gray-600 bg-clip-text text-transparent">
                    Meeting Transactions
                  </h1>
                  <p className="text-gray-600 text-lg">
                    Track payments, platform commission, and mentor earnings
                  </p>
                </div>

              </div>
              <motion.button
                whileHover={{ scale: 1.05 }}
                whileTap={{ scale: 0.95 }}
                onClick={handleDownloadExcel}
                className="bg-gradient-to-r from-green-600 to-emerald-600 text-white px-6 py-3 rounded-xl font-semibold shadow-lg hover:shadow-xl transition-all duration-300 flex items-center gap-2 text-lg"
              >
                <FiDownload className="text-xl" />
                Download Excel
              </motion.button>
            </div>
          </motion.div>

          {/* Filters
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.1 }}
          className="backdrop-blur-xl bg-white/80 border border-white/20 shadow-xl rounded-3xl p-6 mb-8"
        >
          <div className="flex items-center gap-3 mb-4">
            <FiFilter className="text-purple-600 text-xl" />
            <h2 className="text-xl font-semibold text-gray-800">Search & Filter</h2>
          </div>
          <div className="flex flex-col lg:flex-row gap-4 w-full">
            <div className="flex-1 space-y-2">
              <label htmlFor="filter-by" className="text-sm font-semibold text-gray-700">
                Filter By
              </label>
              <select
                id="filter-by"
                value={filter}
                onChange={(e) => setFilter(e.target.value)}
                className="w-full px-4 py-3 bg-gray-50 border border-gray-200 rounded-xl focus:outline-none focus:ring-2 focus:ring-purple-500/20 focus:border-purple-500 text-lg transition-all duration-300"
              >
                <option value="">All</option>
                <option value="startupName">Startup Name</option>
                <option value="fullName">Founder Name</option>
                <option value="email">Email</option>
                <option value="phone">Phone</option>
                <option value="industry">Industry</option>
                <option value="stage">Stage</option>
                <option value="location">Location</option>
                <option value="paymentStatus">Payment Status</option>
              </select>
            </div>
            <div className="flex-1 space-y-2">
              <label htmlFor="search-term" className="text-sm font-semibold text-gray-700 flex items-center gap-2">
                <FiSearch className="text-base" />
                Search Term
              </label>
              <input
                id="search-term"
                type="text"
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
                placeholder="Search startups..."
                className="w-full px-4 py-3 bg-gray-50 border border-gray-200 rounded-xl focus:outline-none focus:ring-2 focus:ring-purple-500/20 focus:border-purple-500 text-lg transition-all duration-300"
              />
            </div>
          </div>
        </motion.div> */}

        {/* Summary Cards */}
<motion.div
  initial={{ opacity: 0, y: -10 }}
  animate={{ opacity: 1, y: 0 }}
  transition={{ delay: 0.1 }}
  className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 mb-8"
>
  {/* Total Revenue */}
   <div className="bg-white/80 backdrop-blur-xl border border-white/20 rounded-2xl shadow-lg p-6">
    <p className="text-sm text-gray-500 mb-1">Total Payment Recieved</p>
    <h2 className="text-3xl font-bold">
      ₹{transactions?.summary?.totalRevenue?.toLocaleString("en-IN") ?? 0}
    </h2>
  </div>
  <div className="bg-white/80 backdrop-blur-xl border border-white/20 rounded-2xl shadow-lg p-6">
    <p className="text-sm text-gray-500 mb-1">Total Revenue</p>
    <h2 className="text-3xl font-bold text-green-600 ">
      ₹{transactions?.summary?.totalCommission?.toLocaleString("en-IN") ?? 0}
    </h2>
  </div>

  {/* Total Commission */}
  
  {/* Mentor Payout */}
  <div className="bg-white/80 backdrop-blur-xl border border-white/20 rounded-2xl shadow-lg p-6">
    <p className="text-sm text-gray-500 mb-1">Total Mentor Payout</p>
    <h2 className="text-3xl font-bold text-gray-900">
      ₹{transactions?.summary?.totalMentorPayout?.toLocaleString("en-IN") ?? 0}
    </h2>
  </div>
</motion.div>


          {/* Table */}
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: 0.2 }}
            className="backdrop-blur-xl bg-white/80 border border-white/20 shadow-xl rounded-3xl p-6 mb-8 overflow-x-auto"
          >
            <table className="min-w-full divide-y divide-gray-200">
              <thead className="bg-gray-50">
                <tr>
                  {[
                    "Date",
                    "Meeting Title",
                    "Startup Name",
                    "Startup Email",
                    "Mentor Name",
                    "Amount Paid",
                    "Commission",
                    "Mentor Payout",
                    "Payment Status",
                    "Order ID",
                    "Payment ID",
                    "View"

                  ].map((h) => (
                    <th
                      key={h}
                      scope="col"
                      className="px-4 py-3 text-left text-sm font-bold text-gray-700 uppercase tracking-wider"
                    >
                      {h}
                    </th>
                  ))}
                </tr>
              </thead>
              <tbody className="bg-white divide-y divide-gray-200">
                {transactions?.data === 0 ? (
                  <tr>
                    <td colSpan={14} className="px-4 py-12 text-center text-gray-500 text-lg">
                      We couldn’t find any appointment transactions.
                    </td>
                  </tr>
                ) : (
                  transactions?.data?.map((row) => {
                    const date = moment(row.createdAt).format("DD MMM YYYY");
                    const time = moment(row.createdAt).format("hh:mm A");
                    return (
                      <tr
                        key={row.transactionId}
                        className="hover:bg-gray-50 transition-colors duration-150"
                      >
                        {/* Date */}
                        <td className="px-4 py-3 whitespace-nowrap text-sm text-gray-800">
                          {date}
                        </td>

                        {/* Time */}
                        {/* <td className="px-4 py-3 whitespace-nowrap text-sm text-gray-800">
                        {time}
                      </td> */}

                        {/* Meeting Title */}
                        <td className="px-4 py-3 whitespace-nowrap text-sm font-medium text-gray-900">
                          {row.meeting?.title || "N/A"}
                        </td>

                        {/* Startup Name */}
                        <td className="px-4 py-3 whitespace-nowrap text-sm text-gray-800">
                          {row.startup?.name}
                        </td>

                        {/* Startup Email */}
                        <td className="px-4 py-3 whitespace-nowrap text-sm text-gray-800">
                          {row.startup?.email}
                        </td>

                        {/* Mentor Name */}
                        <td className="px-4 py-3 whitespace-nowrap text-sm text-gray-800">
                          {row.mentor?.name}
                        </td>

                        {/* Amount Paid */}
                        <td className="px-4 py-3 whitespace-nowrap text-sm font-semibold text-gray-900">
                          ₹{row.amountPaid?.toLocaleString("en-IN")}
                        </td>

                        {/* Commission */}
                        <td className="px-4 py-3 whitespace-nowrap text-sm text-green-600">
                          ₹{row.commissionAmount?.toLocaleString("en-IN")}
                        </td>

                        {/* Mentor Payout */}
                        <td className="px-4 py-3 whitespace-nowrap text-sm  text-red-600">
                          ₹{row.mentorPayout?.toLocaleString("en-IN")}
                        </td>


                        {/* Payment Status */}
                        <td className="px-4 py-3 whitespace-nowrap">
                          <span
                            className={`inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium ${row.payment.status === "PAID"
                              ? "bg-green-100 text-green-800 border border-green-200"
                              : "bg-yellow-100 text-yellow-800 border border-yellow-200"
                              }`}
                          >
                            {row.payment.status}
                          </span>
                        </td>

                        <td className="px-4 py-3 whitespace-nowrap text-sm text-green-600">
                          {row?.payment?.orderId?.slice(0, 10)}..
                        </td>
                        <td className="px-4 py-3 whitespace-nowrap text-sm text-green-600">
                          {row?.payment?.paymentId?.slice(0, 10)}..
                        </td>

                        {/* Actions */}
                        <td className="px-4 py-3 whitespace-nowrap text-right text-sm font-medium">
                          <button
                            className="inline-flex items-center px-3 py-1.5 rounded-lg text-sm font-medium bg-blue-600 text-white hover:bg-blue-700 transition"
                            onClick={() => {
                              setSelectedTransaction(row);
                              setIsModalOpen(true);
                            }}
                          >
                            View
                          </button>
                        </td>
                      </tr>
                    )
                  })
                )}
              </tbody>
            </table>
          </motion.div>


        </div>

        {/* Delete Dialog */}



      </div>

      <AnimatePresence>
        {isModalOpen && selectedTransaction && (
          <motion.div
            className="fixed inset-0 z-50 flex items-center justify-center bg-black/60 backdrop-blur-sm"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
          >
            {/* Modal Card */}
            <motion.div
              className="bg-white rounded-2xl shadow-2xl w-full max-w-2xl p-6 relative"
              initial={{ scale: 0.9, y: 40 }}
              animate={{ scale: 1, y: 0 }}
              exit={{ scale: 0.9, y: 40 }}
              transition={{ duration: 0.25, ease: "easeOut" }}
            >
              {/* Header */}
              <div className="flex justify-between items-center mb-6">
                <h2 className="text-xl font-bold text-gray-900">
                  Transaction Details
                </h2>
                <button
                  onClick={() => setIsModalOpen(false)}
                  className="text-gray-400 hover:text-gray-600 text-xl"
                >
                  ✕
                </button>
              </div>

              {/* Content */}
              <div className="grid grid-cols-2 gap-4 text-sm">
                {/* Meeting */}
                <Detail label="Meeting Title" value={selectedTransaction.meeting?.title || "N/A"} />
                <Detail
                  label="Meeting Date"
                  value={selectedTransaction.meeting?.date
                    ? moment(selectedTransaction.meeting.date).format("DD MMM YYYY")
                    : "N/A"}
                />

                {/* Startup */}
                <Detail label="Startup Name" value={selectedTransaction.startup?.name} />
                <Detail label="Startup Email" value={selectedTransaction.startup?.email} />

                {/* Mentor */}
                <Detail label="Mentor Name" value={selectedTransaction.mentor?.name} />
                <Detail label="Mentor Email" value={selectedTransaction.mentor?.email} />

                {/* Amounts */}
                <Detail label="Amount Paid" value={`₹${selectedTransaction.amountPaid}`} />
                <Detail label="Commission" value={`₹${selectedTransaction.commissionAmount}`} />
                <Detail label="Mentor Payout" value={`₹${selectedTransaction.mentorPayout}`} />

                {/* Payment */}
                <Detail label="Payment Status" value={selectedTransaction.payment?.status} />
                <Detail label="Order ID" value={selectedTransaction.payment?.orderId} />
                <Detail label="Payment ID" value={selectedTransaction.payment?.paymentId} />

                {/* Date */}
                <Detail
                  label="Transaction Time"
                  value={moment(selectedTransaction.createdAt).format("DD MMM YYYY, hh:mm A")}
                />
              </div>

              {/* Footer */}
              <div className="mt-6 flex justify-end">
                <button
                  onClick={() => setIsModalOpen(false)}
                  className="px-4 py-2 rounded-lg bg-gray-100 text-gray-700 hover:bg-gray-200 transition"
                >
                  Close
                </button>
              </div>
            </motion.div>
          </motion.div>
        )}
      </AnimatePresence>

    </>
  )
}

export default MeetingAppointmentTransactions;